<template>
  <div id="dashboard" class="content">
    <div class="row">
      <div class="col-md-6 col-xl-3">
        <a class="block text-center cursor-auto" href="javascript:void(0)">
          <div class="block-content" style="padding-bottom: 1.25rem">
            <div>
              <div
                class="js-pie-chart pie-chart mb-3"
                :data-percent="message&&message.num_meters_online / message.meter_num * 100"
                data-line-width="3"
                data-size="70"
                data-bar-color="#3c90df"
                data-track-color="#e9e9e9"
                style="min-height: 70px"
              >
                <span
                  class="font-size-75"
                >{{message&&message.num_meters_online || 0}}/{{message.meter_num || 0}}</span>
              </div>
              <p class="text-muted mt-2 mb-0 font-size-75">电表(在线数/总数)</p>
            </div>
          </div>
        </a>
      </div>
      <div class="col-md-6 col-xl-3">
        <a class="block text-center cursor-auto" href="javascript:void(0)">
          <div class="block-content" style="padding-bottom: 1.25rem">
            <div>
              <div
                class="js-pie-chart pie-chart mb-3"
                :data-percent="message.num_online / message.pile_num * 100"
                data-line-width="3"
                data-size="70"
                data-bar-color="#82b54b"
                data-track-color="#e9e9e9"
                style="min-height: 70px"
              >
                <span class="font-size-75">{{message.num_online || 0}}/{{message.pile_num || 0}}</span>
              </div>
              <p class="text-muted mt-2 mb-0 font-size-75">充电桩(在线数/总数)</p>
            </div>
          </div>
        </a>
      </div>
      <div class="col-md-6 col-xl-3">
        <a class="block text-center cursor-auto" href="javascript:void(0)" style="cursor: auto">
          <div class="block-content" style="padding-bottom: 1.25rem">
            <div>
              <div
                class="js-pie-chart pie-chart mb-3"
                :data-percent="message.num_port_online / message.num_ports * 100"
                data-line-width="3"
                data-size="70"
                data-bar-color="#f2ad40"
                data-track-color="#e9e9e9"
                style="min-height: 70px"
              >
                <span
                  class="font-size-75"
                >{{message.num_port_online || 0}}/{{message.num_ports || 0}}</span>
              </div>
              <p class="text-muted mt-2 mb-0 font-size-75">端口(在线数/总数)</p>
            </div>
          </div>
        </a>
      </div>
      <div class="col-md-6 col-xl-3">
        <a class="block text-center cursor-auto" href="javascript:void(0)" style="cursor: auto">
          <div class="block-content pt-0" style="padding-bottom: 1.1rem">
            <div>
              <div id="port" style="width: 100%; height: 130px" class="pt-2"></div>
              <!-- <p class="text-muted mt-2 mb-0 font-size-75" style="padding-top:0.25rem">端口(空闲/占用)</p> -->
            </div>
          </div>
        </a>
      </div>
    </div>
    <div class="block-rounded">
      <div class="row">
        <div class="col-sm-3 no-border">
          <div class="block block-rounded block-bordered">
            <div class="block-header block-header-default">
              <h3 class="block-title">
                电表
                <span
                  class="spanStyle"
                >（在线数{{message&&message.num_meters_online||0}}/总数{{message.meter_num||0}}）</span>
              </h3>
            </div>
            <div class="block-content" style="height: 650px;overflow-y: auto">
              <section ref="print">
                <table
                  class="table table-bordered table-vcenter js-dataTable-full dataTable no-footer"
                >
                  <thead>
                    <tr>
                      <th class="text-center" style="width:85px;min-width:85px;">电表名称</th>
                      <th class="text-center" style="width:85px;min-width:85px;">电表串号</th>
                      <th class="text-center" style="width:85px;min-width:85px;">状态</th>
                    </tr>
                  </thead>
                  <tbody v-if="degreeList.length">
                    <tr
                      :class="{'tr-ba-clor ':degreeIndex==i}"
                      v-for="(item, i) in degreeList"
                      :key="i"
                      @click="getChargePie(item.ELECTRICITY_METER_SN,i)"
                    >
                      <td class="text-center">{{ item.ELECTRICITY_METER_NAME||"未命名" }}</td>
                      <td class="text-center d-md-table-cell">{{ item.ELECTRICITY_METER_SN }}</td>
                      <td class="text-center d-xl-table-cell">
                        <span
                          class="badge badge-pill"
                          :class="{'text-success':item.DEVICE_STATE == '1','text-secondary':item.DEVICE_STATE != '1'}"
                        >
                          <i class="fa fa-wifi"></i>
                        </span>
                        <span
                          v-show="item.DEVICE_STATE != '1'"
                          style="color:#ffb119;font-size: 0.8rem;margin-left: -4px;"
                        >!</span>
                      </td>
                    </tr>
                  </tbody>
                  <tbody v-else>
                    <tr>
                      <td class="text-center" colspan="4">查无数据</td>
                    </tr>
                  </tbody>
                </table>
              </section>
            </div>
          </div>
        </div>
        <div class="col-sm-6 no-border">
          <div class="block block-rounded block-bordered">
            <div class="block-header block-header-default">
              <h3 class="block-title">
                充电桩
                <span class="spanStyle">（在线数{{message.num_online||0}}/总数{{message.pile_num||0}}）</span>
              </h3>
            </div>
            <div class="block-content" style="height: 650px;overflow-y: auto">
              <section ref="print">
                <table
                  class="table table-bordered table-vcenter js-dataTable-full dataTable no-footer"
                >
                  <thead>
                    <tr>
                      <th class="text-center" style="width:100px;min-width:100px;">充电桩编号</th>
                      <th class="text-center" style="width:115px;min-width:115px;">设备号</th>
                      <th class="text-center" style="width:115px;min-width:115px;">固件号</th>
                      <th class="text-center" style="width:115px;min-width:115px;">型号</th>
                      <th class="text-center" style="width:85px;min-width:85px;">状态</th>
                    </tr>
                  </thead>
                  <tbody v-if="chargePieList.length">
                    <tr
                      :class="{'tr-ba-clor ':chargePieIndex==i}"
                      v-for="(item, i) in chargePieList"
                      :key="i"
                      @click="getPort(item.CHARGING_PILE_SN,i)"
                    >
                      <td class="text-center d-md-table-cell">{{ item.CHARGING_PILE_NAME }}</td>
                      <td class="text-center">{{ item.CHARGING_PILE_SN }}</td>
                      <td class="text-center">{{ item.HARDWARE_VERSION }}</td>
                      <td class="text-center">{{ item.COMMUNICATION_MODULE }}</td>
                      <td class="text-center d-xl-table-cell deviceStatus">
                        <span
                          class="badge badge-pill"
                          :class="{'text-success':item.DEVICE_STATE == '1','text-secondary':item.DEVICE_STATE != '1', 'wifiDis': item.DEVICE_STATE != '1'}"
                        >
                          <i class="fa fa-wifi"></i>
                        </span>
                        <span class="wifi-error" v-show="item.DEVICE_STATE != '1'">
                          <i class="fa fa-exclamation-circle"></i>
                        </span>
                      </td>
                    </tr>
                  </tbody>
                  <tbody v-else>
                    <tr>
                      <td class="text-center" colspan="5">查无数据</td>
                    </tr>
                  </tbody>
                </table>
              </section>
            </div>
          </div>
        </div>
        <div class="col-sm-3 no-border">
          <div class="block block-rounded block-bordered">
            <div class="block-header block-header-default">
              <h3 class="block-title">
                端口
                <span
                  class="spanStyle"
                >（在线数{{message.num_port_online||0}}/总数{{message.num_ports||0}}）</span>
              </h3>
            </div>
            <div class="block-content" style="height: 650px;overflow-y: auto">
              <section ref="print">
                <table
                  class="table table-bordered table-vcenter js-dataTable-full dataTable no-footer"
                >
                  <thead>
                    <tr>
                      <th class="text-center" style="width: 70px; min-width:70px">端口号</th>
                      <th class="text-center" style="width:85px;min-width:85px;">安装状态</th>
                      <th class="text-center" style="width:85px;min-width:85px;">在线状态</th>
                      <th class="text-center" style="width:85px;min-width:85px;">实时状态</th>
                      <th
                        class="text-center"
                        style="width:70px;min-width:70px;"
                        v-if="setStateBtn"
                      >操作</th>
                    </tr>
                  </thead>
                  <tbody v-if="portList.length">
                    <tr v-for="(item, i) in portList" :key="i">
                      <td class="text-center">{{ item.PORT_ID >9 ?item.PORT_ID:"0"+item.PORT_ID }}</td>
                      <td class="text-center d-xl-table-cell">
                        <span
                          class="badge-pill"
                          :class="{'text-success':item.PORT_STATE != '0','text-secondary':item.PORT_STATE == '0'}"
                        >
                          <i
                            :class="{'fa fa-check-circle': item.PORT_STATE != 0 ,'fa fa-times': item.PORT_STATE == 0}"
                          ></i>
                        </span>
                      </td>
                      <td class="text-center d-xl-table-cell deviceStatus">
                        <span
                          class="badge badge-pill"
                          :class="{'text-success':item.DEVICE_STATE == '1','text-secondary':item.DEVICE_STATE != '1', 'wifiDis': item.DEVICE_STATE != '1'}"
                        >
                          <i class="fa fa-wifi"></i>
                        </span>
                        <span class="wifi-error" v-show="item.DEVICE_STATE != '1'">
                          <i class="fa fa-exclamation-circle"></i>
                        </span>
                      </td>
                      <td class="text-center d-md-table-cell" style="line-height: 100%">
                        <span
                          class="badge"
                          :class="{'badge-secondary': item.PORT_STATE == '2', 
                                 'badge-success': item.PORT_STATE == '1'|| item.PORT_STATE == '0'}"
                        >{{ item.PORT_STATE=="1" || item.PORT_STATE == '0'?"空闲":item.PORT_STATE=="2" ?"占用": ""}}</span>
                      </td>
                      <td class="text-center no-print" v-if="setStateBtn">
                        <div class="btn-group">
                          <a href="javascript:void(0)" @click="reset(item)">重置</a>
                        </div>
                      </td>
                    </tr>
                  </tbody>
                  <tbody v-else>
                    <tr>
                      <td class="text-center" colspan="5">查无数据</td>
                    </tr>
                  </tbody>
                </table>
              </section>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import Util from "../../../Util.js";
import screenTime from "../../../components/screenTime";
import pageSize from "../../../components/pageSize";

export default {
  name: "index",
  data() {
    return {
      degreeList: [],
      chargePieList: [],
      portList: [],
      totalList: [],
      meterId: "",
      degreeIndex: "n",
      chargePieIndex: "n",
      pieId: "",
      cellName: "",
      message: {},
      stateMessage: {},
      setStateBtn: false // Util.isHavePerm("chargePile/updateChargePilePortState")
    };
  },
  components: {
    screenTime,
    pageSize
  },
  computed: {
    params() {
      return this.$store.state.params;
    },
    entry() {
      return this.$store.state.entry;
    },
    userInfo() {
      return this.$store.state.userInfo;
    }
  },
  watch: {},
  mounted() {
    if (this.$route.params.type) {
      this.$store.commit("setParam", {
        params: this.$route.params
      });
    }
    this.getList();
    this.getComplex();
  },
  methods: {
    reset(val) {
      swal("确定重置？", {
        buttons: {
          cancel: {
            text: "取消",
            className: "btn btn-sm btn-light btn-sm-h",
            visible: true
          },
          defeat: {
            text: "确定",
            className: "btn btn-sm btn-primary btn-sm-h"
          }
        }
      }).then(value => {
        switch (value) {
          case "defeat":
            this.$http
              .post(`${Util.operateURL}/chargePile/updateChargePilePortState`, {
                portState: 1,
                chargingPileSn: val.CHARGING_PILE_SN,
                portId: val.PORT_ID
              })
              .then(res => {
                if (res.data.code === 200) {
                  Util.message("succ", res.data.desc);
                  this.getPort(this.pieId, this.chargePieIndex);
                } else {
                  Util.message("err", res.data.desc);
                }
              });
        }
      });
    },
    getList() {
      this.$http
        .get(
          `${Util.searchURL}/Pile/ListByMeterByCell/${this.$route.params.id}/`
        )
        .then(res => {
          if (res.data.code === 200) {
            this.cellName = res.data.data.info.CELL_NAME;
            this.degreeList = res.data.data.meter;
            this.message = res.data.data;
            // let _entry = this.entry;
            // _entry.flat_complex.CELL_NAME = this.cellName;
            // _entry.flat_complex.GPS_LAT = res.data.data.info.GPS_LAT;
            // _entry.flat_complex.GPS_LNG = res.data.data.info.GPS_LNG;
            // this.$store.commit("setParam", {
            //   localSelect: this.cellName,
            //   entry: _entry
            // });
            this.getChargePie(this.degreeList[0].ELECTRICITY_METER_SN, 0);
            $(function() {
              Dashmix.helpers([
                "easy-pie-chart",
                "sparkline",
                "datepicker",
                "flatpickr"
              ]);
            });

            Util.initChart(
              this,
              "port",
              [],
              [
                {
                  value:
                    this.message.num_ports - this.message.num_port_charging,
                  name: "空闲"
                },
                { value: this.message.num_port_charging * 1, name: "占用" }
              ],
              "#FFB119",
              "pie",
              "个"
            );
          }
        });
    },
    getChargePie(id, i) {
      this.degreeIndex = i;
      this.$http
        .get(
          `${Util.searchURL}/Pile/ListByMeterByCell/${this.$route.params.id}/` +
            id
        )
        .then(res => {
          if (res.data.code === 200) {
            this.meterId = id;
            this.chargePieList = res.data.data;
            this.portList = [];
            this.chargePieIndex = "n";
            if (
              this.chargePieList[0] &&
              this.chargePieList[0].CHARGING_PILE_SN
            ) {
              this.getPort(this.chargePieList[0].CHARGING_PILE_SN, 0);
            }
          }
        });
    },
    getPort(id, i) {
      this.pieId = id;
      this.chargePieIndex = i;
      this.portList = [];
      this.$http
        .get(
          `${Util.searchURL}/Pile/ListByMeterByCell/${this.$route.params.id}/` +
            `${this.meterId}` +
            "/" +
            this.pieId
        )
        .then(res => {
          if (res.data.code === 200) {
            this.portList = res.data.data;
          }
        });
    },
    getComplex() {
      //  /api/flatComplexByDistrict/
      //  /FlatComplex/ListByDistrict/
      let str = this.$route.params.id.substring(0, 6);
      if (this.userInfo.role == "agent" || this.userInfo.role == "property") {
        str = this.userInfo.role_id;
        this.$store.commit("setParam", {
          fullscreenLoading: false
        });
        return;
      }
      let url = `${Util.searchURL}/FlatComplex/ListByDistrict/${str}?isMenu=true`;
      if (this.userInfo.role == "op" && !this.userInfo.is_all_cell) return;
      if (this.userInfo.role == "flatComplex") {
        url = `${Util.searchURL}/Tool/Menu/flatComplexByDistrict/${this.$route.params.id}`;
      }
      if (this.userInfo.role == "subAccount") {
        url = `${Util.searchURL}/Tool/Menu/subAccount/${this.userInfo.role_id}`;
      }
      this.$http.get(url).then(
        res => {
          if (res.data.code === 200) {
            this.$store.commit("setParam", {
              menu: res.data.data,
              menuTitle: res.data.data[0].REGION_NAME,
              fullscreenLoading: false
            });
          }
        },
        err => {
          this.$store.commit("setParam", {
            fullscreenLoading: false
          });
          console.log(err);
        }
      );
    }
  }
};
</script>
<style scoped lang="less" scope>
.badge {
  font-weight: 400 !important;
}
.custom-control-inline {
  margin-right: 3rem;
}
.custom-control {
  label {
    font-size: 0.9375rem;
    font-weight: 400;
  }
}
.tr-ba-clor {
  background-color: #e1effe;
}
.no-border {
  .table-bordered th,
  .table-bordered,
  .table-bordered td,
  .table th,
  .table td {
    border: none !important;
    font-size: 0.875rem !important;
  }
  .table tbody + tbody {
    border-top: none;
    font-size: 0.875rem !important;
  }
  .spanStyle {
    font-size: 0.875rem !important;
    color: #6c757d !important;
  }
  .wifiDis {
    color: rgba(0, 0, 0, 0.33) !important;
  }
  .deviceStatus {
    position: relative;
  }
  .wifi-error {
    font-size: 0.32rem;
    position: absolute;
    left: 52%;
    bottom: 37%;
  }
}
</style>